import { useState } from 'react';
import * as R from 'ramda';
import { MdInfoOutline } from 'react-icons/md';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Button } from '@Components/Button';
import { Dropdown } from '@Components/Dropdown';
import { Checkbox } from '@Components/FormCheck';
import { Appearance, Design, Placement } from '@Components/designConstants';
import { RotationsAndPricing } from '../linear-buying-utils';
import './AddNewNetworkModal.scss';

interface AddNewNetworkModalProps {
  rotationsAndPricing: RotationsAndPricing;
  addNewNetwork: (selectedNetwork: string) => void;
  onClose: () => void;
}

export const AddNewNetworkModal = ({
  rotationsAndPricing,
  addNewNetwork,
  onClose
}: AddNewNetworkModalProps) => {
  const [selectedNetwork, setSelectedNetwork] = useState('');
  // These include Ampersand, Wide Orbit, and American Target Networks.
  // There are a lot of them and they aren't relevant to most clients' media plans, so we hide them by default.
  const [showLocalAggregators, setShowLocalAggregators] = useState(false);

  const networkOptions = R.keys(rotationsAndPricing).filter(network =>
    showLocalAggregators
      ? true
      : !network.startsWith('AMP') &&
        !network.startsWith('WO') &&
        !network.startsWith('ATN') &&
        !network.startsWith('ICON')
  );

  return (
    <Modal show onHide={onClose} className='add-new-network-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Select a new network to add</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Dropdown
          searchable
          className='new-network-select'
          placeholder='Select a network'
          options={networkOptions}
          value={selectedNetwork || null}
          onChange={network => setSelectedNetwork(network ?? '')}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className='checkbox'>
          <div className='label'>
            <div className='text'>Show Local Aggregators</div>
            <OverlayTrigger
              placement={Placement.RIGHT_START}
              overlay={
                <Tooltip id='addNetworkTooltip'>
                  These include Ampersand, Wide Orbit, and American Target Networks
                </Tooltip>
              }
            >
              <MdInfoOutline />
            </OverlayTrigger>
          </div>
          <Checkbox
            checked={showLocalAggregators}
            onChange={() => setShowLocalAggregators(!showLocalAggregators)}
          />
        </div>

        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={!selectedNetwork} onClick={() => addNewNetwork(selectedNetwork)}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
